import { render, staticRenderFns } from "./CardStrem.vue?vue&type=template&id=0d01f327"
import script from "./CardStrem.vue?vue&type=script&lang=js"
export * from "./CardStrem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports